import { Box, BoxProps } from '@chakra-ui/react';
import React from 'react';
import { dividerStyles } from '@/views/sports/components/Divider/styles/Divider.styles';

export default function Divider(props: BoxProps) {
  return <Box {...props} {...dividerStyles.boxWrapper} />;
}
